import Crest from "./Crest";
import { scrollToSection } from "../lib/scroll";

const UNION_LINKS = [
  { label: "The Passport", href: "#passport" },
  { label: "Member Nations", href: "#nations" },
  { label: "Youth Parliament", href: "#parliament" },
  { label: "Manifesto", href: "#manifesto" },
  { label: "Join The Movement", href: "#join" },
];

const COUNCILS = ["West Africa — ECOWAS", "East Africa — EAC / IGAD", "Southern Africa — SADC", "North Africa — AMU", "Central Africa — ECCAS"];

export default function Footer() {
  return (
    <footer className="relative border-t border-[#00A651]/15 bg-[#0A0C0E] noise-overlay overflow-hidden" data-testid="main-footer">
      <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto pt-20 pb-10">
        <h2 className="font-display font-extrabold tracking-tight leading-[0.95] text-4xl sm:text-5xl lg:text-6xl" data-testid="footer-headline">
          <span className="block text-[#F7F5F0]">ONE AFRICA.</span>
          <span className="block text-outline-gold">ONE PASSPORT.</span>
        </h2>

        <div className="mt-16 grid md:grid-cols-3 gap-12 border-t border-[#00A651]/12 pt-12">
          <div>
            <div className="flex items-center gap-3">
              <Crest className="w-10 h-10" />
              <p className="font-display font-extrabold text-sm leading-tight">
                UNITED STATES
                <span className="block text-[#00A651]">OF AFRICA</span>
              </p>
            </div>
            <p className="text-sm text-[#8A99AD] leading-relaxed mt-5 max-w-xs">
              A union of 55 nations and one diaspora, initiated by the Kingdom of Kush.
              No borders for the youth. No borders for business. No border for progress.
            </p>
          </div>
          <div>
            <p className="font-official text-[10px] tracking-[0.3em] uppercase text-[#00A651]">The Union</p>
            <ul className="mt-5 space-y-3">
              {UNION_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    onClick={(e) => { e.preventDefault(); scrollToSection(l.href); }}
                    className="text-sm text-[#8A99AD] hover:text-[#00A651] transition-colors duration-300"
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-official text-[10px] tracking-[0.3em] uppercase text-[#00A651]">Regional Councils</p>
            <ul className="mt-5 space-y-3">
              {COUNCILS.map((c) => (
                <li key={c} className="font-official text-[11px] tracking-[0.15em] uppercase text-[#8A99AD]">
                  {c}
                </li>
              ))}
            </ul>
            <p className="mt-6 font-official text-[11px] tracking-[0.15em] text-[#8A99AD]">
              SECRETARIAT@USAFRICA.MOVEMENT
            </p>
            <a
              href="/charter"
              data-testid="footer-charter-link"
              className="mt-3 inline-block font-official text-[11px] tracking-[0.15em] uppercase text-[#00A651] hover:text-[#2FC36A] transition-colors duration-300"
            >
              The Charter — Read Online
            </a>
          </div>
        </div>

        <div className="mt-14 border-t border-[#00A651]/12 pt-8 flex flex-col sm:flex-row justify-between gap-4">
          <p className="font-official text-[10px] tracking-[0.2em] uppercase text-[#8A99AD]/70">
            © 2026 United States of Africa — Initiated by the Kingdom of Kush
          </p>
          <a
            href="/admin"
            data-testid="footer-link-leadership-desk"
            className="font-official text-[10px] tracking-[0.2em] uppercase text-[#8A99AD]/70 hover:text-[#00A651] transition-colors duration-300"
          >
            Leadership Desk
          </a>
          <p className="font-official text-[10px] tracking-[0.2em] uppercase text-[#00A651]/70">
            Africa Without Border
          </p>
        </div>
      </div>
    </footer>
  );
}
